import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ReferralRewardUserProgressModel } from '@shared/types/models';

import { UserProgressesState } from './types';

const initialState: UserProgressesState = {
  userProgressesList: [],
  userProgressesPage: 1,
  userProgressesTotalCount: 0,
  refreshReferralTable: false,
};

export const referralUserProgressSlice = createSlice({
  name: 'referralUserProgress',
  initialState,
  reducers: {
    setReferralUserProgress: (
      state: UserProgressesState,
      { payload }: PayloadAction<ReferralRewardUserProgressModel[]>
    ) => {
      state.userProgressesList = payload;
    },
    setReferralUserProgressPage: (state: UserProgressesState, { payload }: PayloadAction<number>) => {
      state.userProgressesPage = payload;
    },
    setReferralUserProgressTotalCount: (state: UserProgressesState, { payload }: PayloadAction<number>) => {
      state.userProgressesTotalCount = payload;
    },
    refreshReferralTable: (state: UserProgressesState, { payload }: PayloadAction<boolean>) => {
      state.refreshReferralTable = payload;
    },
  },
});

export const {
  setReferralUserProgress,
  setReferralUserProgressPage,
  setReferralUserProgressTotalCount,
  refreshReferralTable,
} = referralUserProgressSlice.actions;

export const referralUserProgressSliceReducer = referralUserProgressSlice.reducer;
